import { FC } from 'react';
import MUIChip, { ChipProps } from '@mui/material/Chip';

export const Chip: FC<ChipProps> = (props) => <MUIChip {...props} />;
